module.exports = __webpack_public_path__ + "img/up.46a6f1a.png";